export var currentFocus;
export var InputSearchCategories;
export var InputSearchProducers;
export var InputSearchQuery;

const inputSearch = document.querySelector('.header__top__search-bar #search-field')
const results = document.querySelector('.header__top__search-bar .search-bar__results');
const dropdownOverlay = document.querySelector('.cart-dropdown__overlay');

export const SearchPreResult = (data, signal) => {
  fetch('/search-pre', {
      signal,
      method: 'post',
      body: JSON.stringify(data),
      headers: {
      'Content-Type': 'application/json'
      }
    })
    .then(result => {
      const p = Promise.resolve(result.json());
      p.then(v => {

        const result_el = document.querySelector('#SearchBarResults')
        if (v.items_count !== 0) {
          result_el.innerHTML = v.html;
        } else {
          result_el.innerHTML = '';
        }
        // console.log(v)
      });
    })
    .catch(err => {
      console.log(err)
    });
}

export const InputSearchListener = () => {
  let controller;
  let signal;
  const outputSearchResults = document.querySelector('#InputSearchResults');
  const searchSubmitButton = document.querySelector('#searchSubmitButton');
  const gcatParam = document.querySelector('#GcatInputSearch');

  if (inputSearch) {
    inputSearch.addEventListener('input', function (e) {
      eventsearch(e);
    });

    inputSearch.addEventListener('click', function (e) {
      if (e.target.value !== "") {
        eventsearch(e);
      }
    });

    function eventsearch(e) {
      if (controller !== undefined) {
        controller.abort();
      }
      if ("AbortController" in window) {
        controller = new AbortController;
        signal = controller.signal;
      }
      const data = {
        "q": e.target.value,
        "p": 1,
        "gcat": gcatParam.value,
      };
      if (data.q.length > 0) {
        //InputSearchQuery = e.target.value;
        SearchPreResult(data, signal);
      }
    }

    inputSearch.addEventListener("keydown", function(e) {
      if (e.keyCode == 40) {
        currentFocus++;
      } else if (e.keyCode == 38) { //up
        currentFocus--;
      } else if (e.keyCode == 13) {
        if(InputSearchQuery.length > 1){
           //window.location.href = "/search?q=" + InputSearchQuery;
        }
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
        }
      }
    });
  }
}


if (inputSearch) {
  inputSearch.addEventListener('focus', () => {
    results.classList.add('search-bar__results--active');
    dropdownOverlay.style.visibility = 'visible';
    dropdownOverlay.style.opacity = '0.8'
    //SearchBarInit()
    InputSearchListener()
  })

  inputSearch.addEventListener('blur', () => {
    setTimeout(() => {
      results.classList.remove('search-bar__results--active')
      dropdownOverlay.style.visibility = ''
      dropdownOverlay.style.opacity = ''
    }, 300)
  })
}
